// Выбор режима PowerSync-БД на вебе: worker (дефолт) или main-thread (фоллбек).
//
// Worker-режим — дефолты @powersync/web v2: SQLite в dedicated worker,
// синк в SharedWorker (multi-tab; SDK сам выключает его на Safari/мобильных).
// Main-thread — прежний safe-режим (IndexedDB VFS без worker'ов), в него
// уводит watchdog из db-impl.web.ts, если worker-режим не открыл БД.
//
// Флаг фоллбека привязан к build id (meta[name="app-version"]): новый деплой —
// новый id, worker-режим пробуется снова. Значение "always" — ручной
// kill-switch, переживающий деплои (см. docs/runbooks/powersync.md).

export const POWERSYNC_MAIN_THREAD_FLAG_KEY = "studyhub:ps-main-thread:v1";

/** Ручной kill-switch: main-thread независимо от build id. */
export const POWERSYNC_MAIN_THREAD_ALWAYS = "always";

export type PowerSyncDbMode = "worker" | "main-thread";

/** Чистый выбор режима — юнит-тестируется без DOM/localStorage. */
export function resolveDbMode(buildId: string, storedFlag: string | null): PowerSyncDbMode {
	if (storedFlag === POWERSYNC_MAIN_THREAD_ALWAYS) return "main-thread";
	return storedFlag === buildId ? "main-thread" : "worker";
}

/** Build id бандла из meta[app-version] (version-inject plugin); в dev — "dev". */
export function readAppBuildId(): string {
	if (typeof document === "undefined") return "dev";
	const meta = document.querySelector<HTMLMetaElement>('meta[name="app-version"]');
	const value = meta?.content?.trim();
	return value && value.length > 0 ? value : "dev";
}

/** Режим для текущей загрузки страницы. Любой сбой чтения = worker (дефолт). */
export function readPowerSyncDbMode(): PowerSyncDbMode {
	try {
		return resolveDbMode(readAppBuildId(), localStorage.getItem(POWERSYNC_MAIN_THREAD_FLAG_KEY));
	} catch {
		// Приватный режим Safari/Firefox может кидать на localStorage.
		return "worker";
	}
}

/**
 * Пометить worker-режим сломанным на ЭТОМ билде: следующая загрузка страницы
 * откроет БД в main-thread-режиме, следующий деплой попробует worker снова.
 *
 * Возвращает `false`, если решение записать НЕ удалось: приватное окно с
 * запретом хранилища, «блокировать данные сайтов», исчерпанная квота origin.
 * Вызывающий обязан это учитывать — перезагрузка без записанного решения
 * повторит ровно тот же путь (см. watchdog в `db-impl.web.ts`).
 */
export function markWorkerModeBroken(): boolean {
	try {
		localStorage.setItem(POWERSYNC_MAIN_THREAD_FLAG_KEY, readAppBuildId());
		return true;
	} catch {
		return false;
	}
}
